import React from 'react';
import ScreenReaderOnly from '../ScreenReaderOnly/ScreenReaderOnly';

export interface ExternalLinkProps extends React.HTMLProps<HTMLAnchorElement> {
  href: string;
  children: React.ReactNode | React.ReactNode[];
}

const ExternalLink = ({ href, target = '_blank', children, ...rest }: ExternalLinkProps) => {
  return (
    <a href={href} rel="noopener noreferrer" target={target} {...rest}>
      {children}
      {target === '_blank' && <ScreenReaderOnly> (opens in a new tab)</ScreenReaderOnly>}
    </a>
  );
};

export default ExternalLink;
